(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-apple"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.ms-apple').forEach(function(root){
    var hero = root.querySelector('[data-ms-hero]');
    var bar = root.querySelector('[data-ms-sticky-bar]');
    if (hero && bar && 'IntersectionObserver' in window) {
      var barObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting) {
            bar.classList.remove('ms-sticky-bar--visible');
          } else if (entry.boundingClientRect.top < 0) {
            bar.classList.add('ms-sticky-bar--visible');
          }
        });
      }, { threshold: 0 });
      barObserver.observe(hero);
    }

    var fadeEls = root.querySelectorAll('.ms-fade-in');
    if ('IntersectionObserver' in window) {
      var fadeObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            fadeObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      fadeEls.forEach(function(el){ fadeObserver.observe(el); });
    } else {
      fadeEls.forEach(function(el){ el.classList.add('is-visible'); });
    }

    var buyForm = root.querySelector('.ms-buy-form');
    if (buyForm) {
      buyForm.addEventListener('submit', function(e){
        e.preventDefault();
        var btn = buyForm.querySelector('[data-ms-add-btn]');
        var errorEl = buyForm.querySelector('[data-ms-buy-error]');
        if (!btn || btn.disabled) return;
        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = '...';
        if (errorEl) errorEl.classList.remove('is-visible');

        var formData = new FormData(buyForm);
        var payload = {};
        formData.forEach(function(value, key){ payload[key] = value; });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function(res){
            return res.json().then(function(data){ return { ok: res.ok, data: data }; });
          })
          .then(function(result){
            if (!result.ok) {
              throw new Error(result.data.description || result.data.message || 'Impossible d ajouter ce produit au panier.');
            }
            window.location.href = '/cart';
          })
          .catch(function(err){
            btn.disabled = false;
            btn.textContent = originalText;
            if (errorEl) {
              errorEl.textContent = err.message;
              errorEl.classList.add('is-visible');
            }
          });
      });
    }

    var quickBuyBtn = root.querySelector('[data-ms-quick-buy]');
    if (quickBuyBtn && buyForm) {
      quickBuyBtn.addEventListener('click', function(){
        if (buyForm.requestSubmit) {
          buyForm.requestSubmit();
        } else {
          buyForm.dispatchEvent(new Event('submit', { cancelable: true }));
        }
      });
    }

    root.querySelectorAll('[data-ms-cross-slider]').forEach(function(slider){
      var track = slider.querySelector('[data-ms-cross-track]');
      var prevBtn = slider.querySelector('[data-ms-cross-prev]');
      var nextBtn = slider.querySelector('[data-ms-cross-next]');
      var dotsWrap = slider.parentElement.querySelector('[data-ms-cross-dots]');
      var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.ms-cross-sell__slide')) : [];
      if (!track || slides.length === 0) return;

      var dots = [];
      if (dotsWrap) {
        slides.forEach(function(slide, i){
          var dot = document.createElement('span');
          dot.className = 'ms-cross-sell__dot' + (i === 0 ? ' is-active' : '');
          dot.addEventListener('click', function(){
            track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          });
          dotsWrap.appendChild(dot);
          dots.push(dot);
        });
      }

      function scrollByCard(dir){
        var card = slides[0];
        var gap = 20;
        track.scrollBy({ left: dir * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }
      if (prevBtn) prevBtn.addEventListener('click', function(){ scrollByCard(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function(){ scrollByCard(1); });

      function updateState(){
        var center = track.scrollLeft + track.clientWidth / 2;
        var closestIndex = 0, closestDist = Infinity;
        slides.forEach(function(s, i){
          var mid = s.offsetLeft + s.clientWidth / 2;
          var dist = Math.abs(mid - center);
          if (dist < closestDist) { closestDist = dist; closestIndex = i; }
        });
        dots.forEach(function(d, i){ d.classList.toggle('is-active', i === closestIndex); });
        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
        if (nextBtn) nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      }
      track.addEventListener('scroll', updateState, { passive: true });
      updateState();
      if (slides.length < 2) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
